<div class=artifact-container>
    <div class="artifact-display" *ngIf="artifact.ArtifactType !== 'daisy_chain_conversation_summary'">
        <app-loading-spinner [text]="''" *ngIf="!loaded"></app-loading-spinner>
        <div class="visual-area" *ngIf="loaded">
            <div *ngIf="artifact.ArtifactType === 'song_recording' && getArtifactBinary()">
              <button (click)="playArtifactAudio(audioPlayer)">
                  <img src='../assets/thumbnails/{{ artifact.ActivityImageName }}.png' style="width:100%">
                  <div class="fit-and-center" *ngIf="audioPlayer.paused">
                      <img class="play-pause-image" src='../assets/Play_1_White.png'>
                  </div>
                  <div class="fit-and-center" *ngIf="!audioPlayer.paused">
                      <img class="play-pause-image" src='../assets/Pause_1.png'>
                  </div>
              </button>
              <audio #audioPlayer (ended)="audioPlayer.pause()">
                  <source [src]="getArtifactBinary()" type="audio/mp3">
              </audio>
            </div>
            <div *ngIf="artifact.ArtifactType === 'speech_rec' && getArtifactBinary()">
                <button (click)="playArtifactAudio(audioPlayer)">
                    <img src='../assets/thumbnails/{{ artifact.ActivityImageName }}.png' style="width:100%">
                    <div class="fit-and-center" *ngIf="audioPlayer.paused">
                        <img class="play-pause-image" src='../assets/Play_1_White.png'>
                    </div>
                    <div class="fit-and-center" *ngIf="!audioPlayer.paused">
                        <img class="play-pause-image" src='../assets/Pause_1.png'>
                    </div>
                </button>
                <audio #audioPlayer (ended)="audioPlayer.pause()">
                    <source [src]="getArtifactBinary()" type="audio/mp3">
                </audio>
            </div>
            <div *ngIf="artifact.ArtifactType === 'colored_page'">
                <img class="fit-and-center" [src]="getArtifactBinary()">
            </div>
        </div>
        <div class="text-area" *ngIf="loaded">
            <div class="artifact-description">
                <h5 style="font-weight: bold; font-size: 1.2vw;">Unit {{ artifact.UnitNumber }} -
                    {{ artifact.ActivityDescription1 }}
                    <span *ngIf="artifact.ActivityDescription1 !== artifact.ActivityDescription2">:
                        {{ artifact.ActivityDescription2 }}</span>
                </h5>
            </div>
            <div class="artifact-footer-container">
                <h2 class="artifact-date">{{ longDateFormat(artifact.DateGenerated) }}</h2>
                <div class="artifact-download">
                    <a *ngIf="artifact.ArtifactType === 'colored_page'" [href]="getArtifactBinary()" ngbTooltip="Download"
                        download="{{artifact.ActivityImageName}}.jpeg"><i class="far fa-download fa-lg"></i></a>
                    <a *ngIf="artifact.ArtifactType !== 'colored_page'" [href]="getArtifactBinary()" ngbTooltip="Download"
                        download="{{artifact.ActivityImageName}}"><i class="far fa-download fa-lg"></i></a>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="artifact.ArtifactType === 'daisy_chain_conversation_summary'">
        <app-daisychain-response *ngFor="let bundledresponse of bundledResponses" [data]="bundledresponse"
            [studentID]="artifact.StudentID" (onVideoLoadStarted)="playWasCalled($event)"
            (onVideoLoaded)="handlePlayResponseVideo($event)">
        </app-daisychain-response>
    </div>
</div>
